import { render } from "./Cronologia.vue?vue&type=template&id=8dcb65be&scoped=true"
import script from "./Cronologia.vue?vue&type=script&lang=js"
export * from "./Cronologia.vue?vue&type=script&lang=js"

import "./Cronologia.vue?vue&type=style&index=0&id=8dcb65be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dcb65be"]])

export default __exports__